import {getTimes} from "../../api/listTime";

const state = () => ({

    todayTimes:[],
})


const getters = {
    get_todayTimes(state) {
        return state.todayTimes;
    },
}

const mutations = {
    SET_TODAYTIMES(state,data){
        // 
        state.todayTimes = data;}
}

const actions = {
    async fetchTodayTimes({ commit }, payload) {
        // 
        const response = await getTimes(payload);
        // 
        commit('SET_TODAYTIMES', response.data);
    },

}




export  default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
